export default __webpack_public_path__ + "assets/e4d78f74e3c3654b6db02ae63e5fac3c.svg";